/*=========================================================================================
  File Name: themeConfig.js
  Description: Theme configuration
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: hhttp://www.themeforest.net/user/pixinvent
==========================================================================================*/

// MAIN COLORS - VUESAX THEME COLORS
const p_color = localStorage.getItem('default_theme_color')
const regExp = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i
const isHexColor = hex => typeof hex === 'string' && hex.length === 6 && !isNaN(Number(`0x${  hex}`))
let is_hex = false
if (p_color) {
  if (isHexColor(p_color) || regExp.test(p_color)) is_hex = true
}
export const colors = {
  primary : is_hex ? p_color : i18n.t('config.colors.primary'),
  success : i18n.t('config.colors.success'),
  danger  : i18n.t('config.colors.danger'),
  warning : i18n.t('config.colors.warning'),
  dark    : i18n.t('config.colors.dark')
}

// CONFIGS
const themeConfig = {
  disableCustomizer :i18n.t('config.disable_customizer') != 'false',       // options[Boolean] : true, false(default)
  disableThemeTour: i18n.t('config.disable_theme_tour') != 'false',        // options[Boolean] : true, false(default)
  footerType: i18n.t('config.footer_type'),    // options[String]  : static(default) / sticky / hidden
  hideScrollToTop: i18n.t('config.hide_scroll_totop') != 'false',       // options[Boolean] : true, false(default)
  // mainLayoutType: i18n.t('config.main_layout_type'),  // options[String]  : vertical(default) / horizontal
  navbarColor: i18n.t('config.navbar_color'),     // options[String]  : HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
  navbarType: i18n.t('config.navbar_type'),  // options[String]  : floating(default) / static / sticky / hidden
  routerTransition:  i18n.t('config.router_transition'),   // options[String]  : zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)
  rtl:i18n.t('config.rtl') != 'false',       // options[Boolean] : true, false(default)
  sidebarCollapsed: i18n.t('config.sidebar_collapsed') != 'false',     // options[Boolean] : true, false(default)
  theme: localStorage.getItem('theme-mode') ? localStorage.getItem('theme-mode') : i18n.t('config.background_color'),     // options[String]  : "light"(default), "dark", "semi-dark"
  AppTitle: i18n.t('config.title'),
  topBarTitle: i18n.t('config.topBarTitle'),
  themeLogo: i18n.t('config.theme_logo'),


  // Not required yet - WIP
  userInfoLocalStorageKey: i18n.t('config.user_infoLocal_storageKey'),

  mainLayoutType: process.env.VUE_APP_MAIN_MENU_TYPE  // options[String]  : vertical(default) / horizontal

  // NOTE: themeTour will be disabled in screens < 1200. Please refer docs for more info.
}

import Vue from 'vue'
import Vuesax from 'vuesax'
import i18n from '@/i18n'

Vue.use(Vuesax, { theme:{ colors }, rtl: themeConfig.rtl })

export default themeConfig
